export default __webpack_public_path__ + "static/KenJavierResume2021-ccc5bb63676dcca759cd439c4fadbc3c.pdf";